import React, { memo } from 'react';

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        width: 'min(1180px, calc(100% - 36px))',
        margin: '0 auto',
        padding: '24px 0 34px',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '20px',
        borderTop: '1px solid var(--game-line)',
        color: 'var(--game-muted)',
        fontSize: '.72rem',
      }}
    >
      <span>© {new Date().getFullYear()} Ângelo Castro</span>
      <span>Senior Software Developer • Tech Lead • Full Stack</span>
    </footer>
  );
};

export default memo(Footer);
